<template>
  <v-container>
    <Mobilephone v-if="step==0" @goToStep="goToStep" />
    <MobilephoneConfirm v-if="step==1" @goToStep="goToStep" :mobilephone="mobilephone" />
    <Email v-if="step==2" @goToStep="goToStep" />
    <EmailConfirm v-if="step==3" @goToStep="goToStep" :email="email" />
    <MobileEmailDone v-if="step==4" @goToStep="goToStep" :email="email" :mobilephone="mobilephone" />
  </v-container>
</template>

<script>
import Mobilephone from "@/components/Registration/Mobilephone";
import MobilephoneConfirm from "@/components/Registration/MobilephoneConfirm";
import Email from "@/components/Registration/Email";
import EmailConfirm from "@/components/Registration/EmailConfirm";
import MobileEmailDone from "@/components/Registration/MobileEmailDone";

// @group Registration
// Styled RegistrationStart component
export default {
  name: "RegistrationStart",

  components: {
    Mobilephone,
    MobilephoneConfirm,
    Email,
    EmailConfirm,
    MobileEmailDone
  },

  data: () => ({
    step: 0,
    mobilephone: "",
    email: ""
  }),

  methods: {
    goToStep(param) {
      if (param && param.step) this.step = param.step;
      if (param && param.mobilephone) this.mobilephone = param.mobilephone;
      if (param && param.email) this.email = param.email;
    }
  }
};
</script>

<style scoped>
</style>
